import { render, staticRenderFns } from "./SyncShopee.vue?vue&type=template&id=34767628&scoped=true"
import script from "./SyncShopee.vue?vue&type=script&lang=js"
export * from "./SyncShopee.vue?vue&type=script&lang=js"
import style0 from "./SyncShopee.vue?vue&type=style&index=0&id=34767628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34767628",
  null
  
)

export default component.exports